export const SUPPORT_EMAIL = "pavlina@testuj.to";
